import { useQuery } from '@tanstack/react-query';
import { useToast } from '@/components/common/toast';
import { useAuth } from '@/auth/AuthContext';
import { http } from '@/api/client/httpClient';
import { consolidatedExposureApi } from '@/api/services/consolidatedExposure';
import type { NopFiltersDto } from '@/api/types/riskDashboard';
import { EodSwapView } from './EodSwapView';

export function EodSwapTab({ filters }: { filters: NopFiltersDto }) {
  const toast = useToast();
  const { tenantId } = useAuth();

  const q = useQuery({
    queryKey: ['ce-eod', tenantId, filters],
    queryFn: () => consolidatedExposureApi.getExpectedEodSwap(tenantId, filters),
  });

  async function exportExcel() {
    try {
      const res = await http.get(consolidatedExposureApi.exportUrl(tenantId), { responseType: 'blob' });
      const cd = String(res.headers['content-disposition'] ?? '');
      const match = cd.match(/filename\*?=(?:UTF-8''|")?([^";]+)/i);
      const fileName = match ? decodeURIComponent(match[1]) : 'Expected EOD Swap.xlsx';
      const url = URL.createObjectURL(res.data as Blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      a.click();
      URL.revokeObjectURL(url);
    } catch {
      toast.error('Export failed. Fetch the tab first, then try again.');
    }
  }

  return (
    <EodSwapView
      snapshot={q.data}
      loading={q.isLoading}
      isError={q.isError}
      onRecalculate={() => q.refetch()}
      onExport={exportExcel}
    />
  );
}
